<template>
  <div class="right-v2">
    <div class="flex">
      <div class="flex-1">行列互换</div>
      <el-switch
        active-color="#13ce66"
        @change="formOrientationChange"
        v-model="config.formOrientation"
        inactive-color="#ff4949"
        active-value="1"
        inactive-value="0"
      >
      </el-switch>
    </div>
    <div class="flex-1 flex-column">
      <div class="flex-1 flex-column item-lump">
        <div class="flex-80 flex item-lump-title">
          <div class="flex-1">测量点</div>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            @click="addMeasure"
            >添加</el-button
          >
        </div>
        <div class="list1">
          <div
            class="item"
            v-for="(item, index) in config.measures"
            :key="index"
          >
            <div class="item-title" :title="item.measureName">
              {{ item.measureName }}
            </div>
            <el-button
              type="text"
              icon="el-icon-delete"
              title="删除"
              @click="delMeasure(item, index)"
            ></el-button>
          </div>
        </div>
      </div>
      <div class="flex-1 flex-column item-lump">
        <div class="flex-80 flex item-lump-title">
          <div class="flex-1">数据项</div>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            @click="addDataItem"
            >添加</el-button
          >
        </div>
        <div class="list1">
          <div class="item" v-for="(item, index) in config.items" :key="index">
            <div class="item-title" :title="item.name">{{ item.name }}</div>
            <el-button
              type="text"
              icon="el-icon-edit"
              title="修改"
              @click="editDataItem(item, index)"
            ></el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              title="删除"
              @click="delDataItem(index)"
            ></el-button>
          </div>
        </div>
      </div>
      <div class="flex-1 flex-column item-lump">
        <div class="flex-80 flex item-lump-title">
          <div class="flex-1">数据加工</div>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-circle-plus"
            @click="addProcesse"
            >添加</el-button
          >
        </div>
        <div class="list1">
          <div
            class="item"
            v-for="(item, index) in config.processes"
            :key="index"
          >
            <div class="item-title" :title="item.name">{{ item.name }}</div>
            <el-button
              type="text"
              icon="el-icon-edit"
              title="修改"
              @click="editProcesse(item, index)"
            ></el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              title="删除"
              @click="delProcesse(index)"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 测量点 -->
    <msg-box
      :visible="addMeasureVisible"
      title="添加测量点"
      @cancel="addMeasureVisible = false"
      @confirm="addMeasureConfirm"
    >
      <div class="data-item-content">
        <el-form ref="dataItemFrom" size="small" label-width="100px">
          <el-form-item label="视图列表" prop="style">
            <el-select
              placeholder="请选择"
              v-model="viewId"
              @change="viewChange"
            >
              <el-option
                v-for="(item, index) in viewData"
                :key="index"
                :label="item.displayName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视图节点树">
            <div style="width: 100%;overflow-x: auto;height: 300px;">
              <el-tree
                ref="tree"
                node-key="id"
                :highlight-current="true"
                style="height: 100%;"
                :data="treeData"
                :props="props"
              >
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </msg-box>
    <!-- 数据项 -->
    <msg-box
      :visible="dataItemVisible"
      :title="dataItemFromTitle"
      @cancel="dataItemVisible = false"
      @confirm="dataItemFromConfirm"
    >
      <div class="data-item-content">
        <el-form
          ref="dataItemFrom"
          :model="dataItemFrom"
          :rules="dataItemFromRules"
          size="small"
          label-width="100px"
        >
          <el-form-item label="显示名称" prop="name">
            <el-input v-model="dataItemFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="style">
            <el-select
              placeholder="请选择类型"
              v-model="dataItemFrom.style"
              @change="dataItemFromStyleChange"
            >
              <el-option label="常量" value="0"></el-option>
              <el-option label="测量点公式" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="类型值"
            v-if="dataItemFrom.style === '0'"
            prop="value"
          >
            <el-input v-model="dataItemFrom.value"></el-input>
          </el-form-item>
          <el-form-item
            label="类型值"
            v-if="dataItemFrom.style === '1'"
            prop="value"
          >
            <el-select
              placeholder="请选择测量点公式"
              v-model="dataItemFrom.value"
            >
              <el-option
                v-for="(item, index) in dataItems"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </msg-box>

    <!-- 加工-->
    <msg-box
      :visible="processeVisible"
      :title="processeFromTitle"
      @cancel="processeVisible = false"
      @confirm="processeFromConfirm"
    >
      <div class="data-item-content">
        <el-form
          ref="processeFrom"
          :model="processeFrom"
          :rules="processeFromRules"
          size="small"
          label-width="100px"
        >
          <el-form-item label="显示名称" prop="name">
            <el-input v-model="processeFrom.name"></el-input>
          </el-form-item>
          <el-form-item label="算法" prop="math">
            <el-select placeholder="不选即默认" v-model="processeFrom.math">
              <el-option label="无" value="null"></el-option>
              <el-option label="最大值" value="max"></el-option>
              <el-option label="最小值" value="min"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="走势分析" prop="trendAnalysis">
            <el-select
              placeholder="不选即默认"
              v-model="processeFrom.trendAnalysis"
            >
              <el-option label="无" value="null"></el-option>
              <el-option label="同期" value="samePeriod"></el-option>
              <el-option label="环期" value="lastPeriod"></el-option>
              <el-option label="同比" value="year-on-year"></el-option>
              <el-option label="环比" value="month-on-month"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </msg-box>
  </div>
</template>

<script>
import MsgBox from "@/components/common/MsgBox";
import Api from "@common/api/index.js";
import tree from "@/utils/tree";
export default {
  components: { MsgBox },
  data() {
    return {
      lock: true,
      // 自定义报表配置文件
      config: {
        version: "2",
        formOrientation: 0, //表单方向, 0:水平, 1:垂直
        items: [],
        measures: [],
        processes: [],
      },
      /**
       * 测量点部分
       */
      addMeasureVisible: false,
      viewData: [],
      viewId: null,
      treeData: [],
      treeNodeData: [],
      props: {
        label: "measureName",
        children: "children",
      },
      /**
       * 数据项部分
       */
      dataItems: window.baseConfig.collectData, //表类型
      dataItemFromTitle: "",
      dataItemVisible: false,
      dataItemFrom: {},
      dataItemFromRules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        style: [{ required: true, message: "请输入名称", trigger: "blur" }],
        value: [{ required: true, message: "类型值为必填", trigger: "blur" }],
      },

      /**
       * 加工部分
       */
      processeVisible: false,
      processeFromTitle: "",
      processeFrom: {},
      processeFromRules: {
        name: [{ required: true, message: "请输入显示名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    formOrientationChange() {
      this.setUserDefinedStatements();
    },
    /**
     * 测量点部分
     */
    // 添加测量点
    addMeasure() {
      this.addMeasureVisible = true;
      this.getAllViewData();
    },
    delMeasure(item, index) {
      this.config.measures.splice(index, 1);
      this.setUserDefinedStatements();
    },
    // 获取所有的视图
    getAllViewData() {
      Api.view
        .getCompanyViewTreesInfo(this.$store.state.user.currentCompanyId)
        .then((res) => {
          if (res && res.data) {
            this.viewData = res.data;
            this.viewId = res.data[0].id;
            this.getViewNodeData(this.viewId);
          } else {
            this.viewData = [];
          }
        });
    },
    viewChange(id) {
      this.getViewNodeData(id);
    },
    addMeasureConfirm() {
      const data = this.$refs["tree"].getCurrentNode();
      if (data) {
        // 查重复
        const index = this.config.measures.findIndex(
          (c) => c.measureId === data.measureId
        );
        if (index === -1) {
          this.config.measures.push({
            measureId: data.measureId,
            measureName: data.measureName,
          });
        }
      }
      this.addMeasureVisible = false;
      this.setUserDefinedStatements();
    },
    // 获取视图的节点列表
    getViewNodeData(viewId) {
      let vm = this;
      Api.view.getViewTreeNodes(viewId).then((res) => {
        if (res && res.data) {
          vm.treeNodeData = res.data;
          vm.treeData = tree.creatTreeJson(res.data, "0");
        } else {
          vm.treeNodeData = [];
          vm.treeData = [];
        }
      });
    },
    /**
     * 数据项的操作部分
     */
    addDataItem() {
      this.dataItemFromTitle = "添加数据项";
      this.dataItemFrom = {
        name: "",
        style: "0",
        value: "",
      };
      this.dataItemVisible = true;
    },
    dataItemFromStyleChange() {
      this.$refs["dataItemFrom"].clearValidate();
      this.dataItemFrom.value = "";
    },
    editDataItem(item, index) {
      this.dataItemFromTitle = "修改数据项";
      const obj = JSON.parse(JSON.stringify(item));
      this.dataItemFrom = {
        name: obj.name,
        style: obj.defaultValue.style,
        value: obj.defaultValue.value,
        index: index,
      };
      this.dataItemVisible = true;
    },
    dataItemFromConfirm() {
      this.$refs["dataItemFrom"].validate((valid) => {
        if (valid) {
          const { name, style, value, index } = this.dataItemFrom;
          console.log(index);
          if (index === undefined) {
            this.config.items.push({
              name: name,
              defaultValue: { style: style, value: value },
            });
          } else {
            this.config.items[index] = {
              name: name,
              defaultValue: { style: style, value: value },
            };
          }
          this.dataItemVisible = false;
          this.setUserDefinedStatements();
        }
      });
    },
    delDataItem(index) {
      this.config.items.splice(index, 1);
      this.setUserDefinedStatements();
    },
    /**
     * 加工
     */
    addProcesse() {
      this.processeFromTitle = "添加数据加工";
      this.processeFrom = {
        name: "",
        math: "null",
        trendAnalysis: "null",
      };
      this.processeVisible = true;
    },
    editProcesse(item, index) {
      this.processeFromTitle = "修改数据加工";
      const { name, math, trendAnalysis } = item;
      this.processeFrom = {
        name: name,
        math: math ? math : "null",
        trendAnalysis: trendAnalysis ? trendAnalysis : "null",
        index: index,
      };
      this.processeVisible = true;
    },
    delProcesse(index) {
      this.config.processes.splice(index, 1);
      this.setUserDefinedStatements();
    },
    processeFromConfirm() {
      this.$refs["processeFrom"].validate((valid) => {
        if (valid) {
          const { name, math, trendAnalysis, index } = this.processeFrom;
          // if (math === 'null' && trendAnalysis === 'null') {
          //   this.$message({
          //     message: '算法和走势分析必填一项',
          //     type: 'warning'
          //   });
          //   return
          // }
          let mathDispose = math === "null" ? null : math;
          let trendAnalysisDispose =
            trendAnalysis === "null" ? null : trendAnalysis;
          if (index === undefined) {
            this.config.processes.push({
              name: name,
              math: mathDispose,
              trendAnalysis: trendAnalysisDispose,
            });
          } else {
            this.config.processes[index] = {
              name: name,
              math: mathDispose,
              trendAnalysis: trendAnalysisDispose,
            };
          }
          this.setUserDefinedStatements();
          this.processeVisible = false;
        }
      });
    },

    /**
     * 保存自定义报表
     */
    setUserDefinedStatements() {
      let vm = this;
      let config = JSON.parse(JSON.stringify(vm.config));
      const measures = config.measures;
      config.measures = [];
      for (let i = 0; i < measures.length; i++) {
        config.measures.push(measures[i].measureId);
      }
      if (vm.lock === false) {
        vm.$emit("save", config);
      }
    },

    // 初始化配置信息
    async init(data) {
      let config = data;
      if (config) {
        console.log("开始初始化自定义报表右边配置信息");
        console.log(config);
        // 获取计量点信息
        if (config.measures.length > 0) {
          const res = await Api.measure.getMeasuresInfo(config.measures);
          if (res || res.data) {
            let measures = [];
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i];
              measures.push({
                measureId: element.id,
                measureName: element.name,
              });
            }
            config.measures = measures;
          }
        }
        console.log(config);
        this.config = config;
      } else {
        this.config = {
          version: "2",
          formOrientation: 0, //表单方向, 0:水平, 1:垂直
          items: [],
          measures: [],
          processes: [],
        };
      }
      this.lock = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
.right-v2 {
  display: flex;
  padding: 6px 0px;

  width: 100%;
  height: 100%;
  flex-flow: column;
  color: #666;
  .flex-column {
    display: flex;
    flex-flow: column;
  }
  .item-lump {
    padding-top: 6px;
    .item-lump-title {
      border-bottom: 1px solid #d6d6d6;
    }
  }
  .flex-80 {
    flex: 0 0 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
  }
}
.flex-1 {
  flex: 1;
  overflow: auto;
}
.flex {
  display: flex;
}
.data-item-content {
  width: 400px;
  padding: 0px 10px;
}
</style>

<style lang="scss">
.right-v2 {
  .el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    // top: 70%;
    // left: -31px;
  }
}
</style>
